import { render, staticRenderFns } from "./activeChatCompose.vue?vue&type=template&id=7210710e&"
import script from "./activeChatCompose.vue?vue&type=script&lang=js&"
export * from "./activeChatCompose.vue?vue&type=script&lang=js&"
import style0 from "./activeChatCompose.vue?vue&type=style&index=0&id=7210710e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports